// src/utils/generateLocalPdf.js

import { PDFDocument, rgb, StandardFonts } from "pdf-lib";
import he from "he";

export const generateLocalPdf2 = async (summaryData) => {
  const templateUrl = "/pdf-templates/template-angebot.pdf";

  // Загружаем template из public
  const templateBytes = await fetch(templateUrl).then((res) =>
    res.arrayBuffer()
  );
  const pdfDoc = await PDFDocument.load(templateBytes);

  const page = pdfDoc.getPages()[0];
  const { width, height } = page.getSize();

  const font = await pdfDoc.embedFont(StandardFonts.Helvetica);
  const fontBold = await pdfDoc.embedFont(StandardFonts.HelveticaBold);

  const {
    angebotId,
    angebotCreatedAt,
    firstName,
    lastName,
    birthDate,
    geburtsort,
    email,
    telefon,
    fuehrerscheinNummer,
    ausgewaehlterPreis,
    anfrage_ausbildung,
    ausbildung_theorie,
    ausbildung_praxis,
    preise,
    klass,
    variant,
    variantName,
    strasse,
    hausnummer,
    plz,
    ort,
  } = summaryData;

  const drawLabelValue = (label, value, x, y) => {
    if (label) {
      page.drawText(`${label} ${value ?? "-"}`, {
        x,
        y,
        size: 10,
        font,
        color: rgb(0, 0, 0),
      });
    } else {
      page.drawText(`${value ?? "-"}`, {
        x,
        y,
        size: 10,
        font,
        color: rgb(0, 0, 0),
      });
    }
  };

  const drawList = (title, items, startX, startY) => {
    let y = startY;
    page.drawText(`${title}:`, {
      x: startX,
      y,
      size: 11,
      font: fontBold,
      color: rgb(0, 0, 0),
    });
    y -= 14;

    if (Array.isArray(items) && items.length > 0) {
      items.forEach((item) => {
        const cleanItem = he.decode(item);
        page.drawText(cleanItem, {
          x: startX + 10,
          y,
          size: 10,
          font,
          color: rgb(0, 0, 0),
        });
        y -= 14;
      });
    } else {
      page.drawText(`— keine Einträge`, {
        x: startX + 10,
        y,
        size: 10,
        font,
        color: rgb(0, 0, 0),
      });
      y -= 14;
    }

    return y;
  };

  const parseHtmlToListItems = (htmlString) => {
    const div = document.createElement("div");
    div.innerHTML = htmlString;

    const items = [];

    // Сначала ищем все li
    div.querySelectorAll("li").forEach((li) => {
      items.push(li.textContent.trim());
    });

    // Если нет li — попробуем просто текст по абзацам
    if (items.length === 0) {
      div.querySelectorAll("p").forEach((p) => {
        const text = p.textContent.trim();
        if (text) {
          items.push(text);
        }
      });
    }

    // Если всё пусто — fallback
    if (items.length === 0) {
      const fallbackText = div.textContent.trim();
      if (fallbackText) {
        items.push(fallbackText);
      }
    }

    return items;
  };

  const drawPriceBlock = (item, startX, startY) => {
    const title = he.decode(item.kategorieName);
    const formattedPrice = `${Number(item.preis).toLocaleString("de-DE")} €`;
    const description = he.decode(item.kategorieBeschreibung);

    let firstLine = "";
    let secondLine = "";

    const firstVonIndex = description.indexOf(" von ");
    if (firstVonIndex !== -1) {
      firstLine = "Fahrstunden von";
      secondLine = description.substring(firstVonIndex + 5).trim();
    } else {
      firstLine = description;
      secondLine = "";
    }

    const headerText = `${title}: ${formattedPrice}`;
    page.drawText(headerText, {
      x: startX,
      y: startY,
      size: 10,
      font: fontBold,
      color: rgb(0, 0, 0),
    });

    let descY = startY - 14;

    page.drawText(`(${firstLine}`, {
      x: startX,
      y: descY,
      size: 9,
      font: font,
      color: rgb(0, 0, 0),
    });
    descY -= 12;

    page.drawText(`${secondLine})`, {
      x: startX,
      y: descY,
      size: 9,
      font: font,
      color: rgb(0, 0, 0),
    });
  };

  // ===== Content =====

  // Angebot Nr. | Date
  page.drawText("Ausbildungsauftrag Nr. ", {
    x: 57,
    y: 740,
    size: 14,
    font: fontBold,
    color: rgb(0, 0, 0),
  });

  const angebotNrValue = `${angebotId ?? "-"}`;
  const labelWidth = fontBold.widthOfTextAtSize("Ausbildungsauftrag Nr. ", 14);
  page.drawText(angebotNrValue, {
    x: 57 + labelWidth,
    y: 740,
    size: 14,
    font,
    color: rgb(0, 0, 0),
  });

  const valueWidth = font.widthOfTextAtSize(angebotNrValue, 14);
  const extraSpacing = 5;
  const dateSpacing = 5;

  page.drawText("|", {
    x: 57 + labelWidth + valueWidth + extraSpacing,
    y: 740,
    size: 14,
    font,
    color: rgb(0, 0, 0),
  });

  const pipeWidth = font.widthOfTextAtSize("|", 14);

  page.drawText(angebotCreatedAt ?? "-", {
    x: 57 + labelWidth + valueWidth + extraSpacing + pipeWidth + dateSpacing,
    y: 740,
    size: 14,
    font,
    color: rgb(0, 0, 0),
  });

  drawLabelValue("Führerschein: Klasse", klass, 57, 720);
  drawLabelValue(
    "Ausbildungsvariante:",
    `${variantName} (${variant})`,
    57,
    708
  );

  page.drawText("Auftrag für den oben angeführten Ausbildungsgegenstand,", {
    x: 57,
    y: 680,
    size: 10,
    font: font,
    color: rgb(0, 0, 0),
  });
  page.drawText("abgeschlossen zwischen Fahrschule ORANGEdrivers und:", {
    x: 57,
    y: 668,
    size: 10,
    font: font,
    color: rgb(0, 0, 0),
  });

  // // Personendaten
  // drawLabelValue("", `${firstName} ${lastName}`, 57, 723);
  // drawLabelValue("", `+${telefon}`, 57, 709);
  // drawLabelValue("", email, 57, 697);

  const startY = 640;
  const lineHeight = 10; // чуть больше расстояние между строками

  // Функция для упрощённого рисования текста
  const drawText = (text, x, y) => {
    page.drawText(text, {
      x,
      y,
      size: 10,
      font: font,
      color: rgb(0, 0, 0),
    });
  };

  // Левый блок — массив строк
  const date = new Date(birthDate);
  const formattedDate = `${String(date.getDate()).padStart(2, "0")}.${String(
    date.getMonth() + 1
  ).padStart(2, "0")}.${date.getFullYear()}`;

  const leftBlock = [
    `${firstName} ${lastName}`,
    `${strasse} ${hausnummer}`,
    `${plz} ${ort}`,
    "",
    `${email}`,
    `${telefon}`,
  ];

  // Правый блок — массив строк
  const rightBlock = [
    "", // пустая строка даст "пропуск" по высоте
    // `Beantragte Klasse: ${klass}, ${variantName}`,
    // `Anmeldedatum: ${angebotCreatedAt}`,
    `${formattedDate}`,
    `${geburtsort}`,
  ];

  // Отрисовка левого блока
  leftBlock.forEach((line, index) => {
    drawText(line, 57, startY - index * lineHeight);
  });

  // Отрисовка правого блока
  rightBlock.forEach((line, index) => {
    drawText(line, 250, startY - index * lineHeight);
  });

  // page.drawText(
  //   "Alle angeführten Paketpreise lt. Leistungsverzeichnis (siehe Folder) beinhalten",
  //   {
  //     x: 57,
  //     y: 565,
  //     size: 9,
  //     font: fontBold,
  //     color: rgb(0, 0, 0),
  //   }
  // );
  // page.drawText(
  //   "gesetzl. vorgeschriebeneTheoretische Einheiten, sowie Fahrlektionen laut",
  //   {
  //     x: 57,
  //     y: 553,
  //     size: 9,
  //     font: fontBold,
  //     color: rgb(0, 0, 0),
  //   }
  // );
  // page.drawText(
  //   "gebuchten Zeitpaket sowie 1 PC Prüfungstermin und 1 Fahrprüfung je gebuchter Klasse.",
  //   {
  //     x: 57,
  //     y: 541,
  //     size: 9,
  //     font: fontBold,
  //     color: rgb(0, 0, 0),
  //   }
  // );

  // page.drawText(
  //   "Exklusive: Überstundenzuschlag, Lehrunterlagen, ärztliches Gutachten,",
  //   {
  //     x: 57,
  //     y: 520,
  //     size: 9,
  //     font: font,
  //     color: rgb(0, 0, 0),
  //   }
  // );
  // page.drawText("Erste Hilfe Kurs und behördliche Gebühren.", {
  //   x: 57,
  //   y: 508,
  //   size: 9,
  //   font: font,
  //   color: rgb(0, 0, 0),
  // });

  // Anfrage
  //   page.drawText('Deine Anfrage', {
  //     x: 57,
  //     y: 650,
  //     size: 10,
  //     font: fontBold,
  //     color: rgb(0, 0, 0),
  //   });

  //   drawLabelValue('Führerschein: Klasse', klass, 57, 638);
  //   drawLabelValue('Ausbildungsvariante:', `${variantName} (${variant})`, 57, 626);

  //   drawLabelValue('', `Liebe(r) ${firstName},`, 57, 595);

  page.drawText("Leistungsverzeichnis", {
    x: 57,
    y: 540,
    size: 13,
    font: fontBold,
    color: rgb(0, 0, 0),
  });

  const theorieItems = parseHtmlToListItems(ausbildung_theorie || "");
  const praxisItems = parseHtmlToListItems(ausbildung_praxis || "");

  let nextY = drawList("Theoretischer Teil", theorieItems, 77, 510);
  nextY = drawList("Praktischer Teil", praxisItems, 77, nextY - 10);

  // теперь nextY — это Y-позиция под списком
  // добавляем отступ перед блоком "Dein Preis"
  const priceBlockStartY = nextY - 20; // можно поиграться с числом (30-40 — обычно норм)

  page.drawText("Dein Preis", {
    x: 77,
    y: priceBlockStartY,
    size: 11,
    font: fontBold,
    color: rgb(0, 0, 0),
  });

  // page.drawText("(inkl. Bearbeitungsgebühr, exkl. behördliche Gebühren):", {
  //   x: 77,
  //   y: priceBlockStartY - 15,
  //   size: 10,
  //   font: font,
  //   color: rgb(0, 0, 0),
  // });

  const selectedPriceObj = Array.isArray(preise)
    ? preise.find(
        (p) => String(Number(p.preis)) === String(Number(ausgewaehlterPreis))
      )
    : null;

  if (selectedPriceObj) {
    const title = he.decode(selectedPriceObj.kategorieName || "");
    const formattedPrice = `${Number(selectedPriceObj.preis).toLocaleString(
      "de-DE",
      { minimumFractionDigits: 0, maximumFractionDigits: 0 }
    )} €`;
    const description = he.decode(selectedPriceObj.kategorieBeschreibung || "");

    // Координаты
    const x = 87;
    const y = priceBlockStartY - 14;

    // Первая строка — заголовок + цена
    page.drawText(`${title}: ${formattedPrice}`, {
      x,
      y,
      size: 10,
      font: fontBold,
      color: rgb(0, 0, 0),
    });

    // Вторая строка — описание
    page.drawText(`(${description})`, {
      x,
      y: y - 12, // на 12 пунктов ниже
      size: 10,
      font: font,
      color: rgb(0, 0, 0),
    });
  } else {
    page.drawText(
      ausgewaehlterPreis
        ? `${Number(ausgewaehlterPreis).toLocaleString("de-DE")} €`
        : "—",
      {
        x: 87,
        y: priceBlockStartY - 14,
        size: 10,
        font: fontBold,
        color: rgb(0, 0, 0),
      }
    );
  }


   page.drawText(
    "Inkludiert: Theoretischer Teil, Praktischer Teil (Fahrstunden laut gebuchtem Zeitpaket)",
    {
      x: 87,
      y: priceBlockStartY - 40,
      size: 9,
      font: font,
      color: rgb(0, 0, 0),
    }
  );
  page.drawText(
    "sowie 1 PC-Prüfungstermin und 1 Fahrprüfung je gebuchter Klasse",
    {
      x: 87,
      y: priceBlockStartY - 50,
      size: 9,
      font: font,
      color: rgb(0, 0, 0),
    }
  );
  page.drawText(
    "Nicht inkludiert: Überstundenzuschlag, Lehrunterlagen, ärztliches Gutachten, Erste-Hilfe-Kurs, behördliche Gebühren.",
    {
      x: 87,
      y: priceBlockStartY - 70,
      size: 9,
      font: font,
      color: rgb(0, 0, 0),
    }
  );

  page.drawText(
    "Die absolvierten Ausbildungsschritte sind laut Gesetz 18 Monate gültig.",
    {
      x: 87,
      y: priceBlockStartY - 90,
      size: 9,
      font: font,
      color: rgb(0, 0, 0),
    }
  );
  page.drawText(
    "Ist das Einhalten bereits gebuchter Fahreinheiten oder Prüfungen nicht möglich, so sind diese fristgerecht bei Fahr-",
    {
      x: 87,
      y: priceBlockStartY - 100,
      size: 9,
      font: font,
      color: rgb(0, 0, 0),
    }
  );
  page.drawText(
    "einheiten 3 Werktage davor, PC am Mittwoch und Fahrprüfung am Freitag vor dem Prüfungstermin schriftlich abzusagen,",
    {
      x: 87,
      y: priceBlockStartY - 110,
      size: 9,
      font: font,
      color: rgb(0, 0, 0),
    }
  );
  page.drawText("andernfalls sind diese zu 100% zu bezahlen. Es gelten die AGB der Fahrschule ORANGEdrivers.", {
    x: 87,
    y: priceBlockStartY - 120,
    size: 9,
    font: font,
    color: rgb(0, 0, 0),
  });

  // например, после Dein Preis блока — выбираем начальное Y
  const signatureStartY = priceBlockStartY - 180; // подбираем отступ вниз

  // позиции по X
  const leftX = 87;
  const rightX = 370; // подбери под свой макет — 300-320 обычно ок

  // Рисуем заголовки
  page.drawText("Unterschrift Auszubildender", {
    x: leftX,
    y: signatureStartY - 65,
    size: 10,
    font: fontBold,
    color: rgb(0, 0, 0),
  });

  page.drawText("Ort / Datum", {
    x: leftX,
    y: signatureStartY - 15,
    size: 10,
    font: fontBold,
    color: rgb(0, 0, 0),
  });

  page.drawText("Unterschrift Erziehungsberechtigter", {
    x: rightX,
    y: signatureStartY - 65,
    size: 10,
    font: fontBold,
    color: rgb(0, 0, 0),
  });

  // Рисуем "линию" для подписи (можно просто нарисовать текст из подчёркиваний)
  page.drawText("__________________________________", {
    x: leftX,
    y: signatureStartY,
    size: 10,
    font: font,
    color: rgb(0, 0, 0),
  });
  page.drawText("__________________________________", {
    x: leftX,
    y: signatureStartY - 50,
    size: 10,
    font: font,
    color: rgb(0, 0, 0),
  });

  page.drawText("__________________________________", {
    x: rightX,
    y: signatureStartY - 50,
    size: 10,
    font: font,
    color: rgb(0, 0, 0),
  });

  const today = new Date();
  const formattedDateToday = `${String(today.getDate()).padStart(
    2,
    "0"
  )}.${String(today.getMonth() + 1).padStart(2, "0")}.${today.getFullYear()}`;

  // const angebotDate = new Date(angebotCreatedAt);
  // const formattedAngebotDate = `${String(angebotDate.getDate()).padStart(2, '0')}.${String(angebotDate.getMonth() + 1).padStart(2, '0')}.${angebotDate.getFullYear()}`;

  // Рисуем дату по центру или слева
  // const datumStr = `Datum: ${formattedDateToday}`; // сюда подставляем дату

  // page.drawText(datumStr, {
  //   x: leftX,
  //   y: signatureStartY - 60,
  //   size: 10,
  //   font: font,
  //   color: rgb(0, 0, 0),
  // });

  // Guarantee Section
  //   page.drawText('Wir garantieren Prüfungstermine!', {
  //     x: 77,
  //     y: 185,
  //     size: 10,
  //     font: fontBold,
  //     color: rgb(0, 0, 0),
  //   });
  //   page.drawText('jeden Montag theoretische Prüfung in Baden', {
  //     x: 77,
  //     y: 171,
  //     size: 10,
  //     font: font,
  //     color: rgb(0, 0, 0),
  //   });
  //   page.drawText('jeden Dienstag theoretische Prüfung in Traiskirchen', {
  //     x: 77,
  //     y: 157,
  //     size: 10,
  //     font: font,
  //     color: rgb(0, 0, 0),
  //   });
  //   page.drawText('jeden Freitag praktische Prüfung in Baden', {
  //     x: 77,
  //     y: 143,
  //     size: 10,
  //     font: font,
  //     color: rgb(0, 0, 0),
  //   });

  // Save & open PDF
  const pdfBytes = await pdfDoc.save();

  const blob = new Blob([pdfBytes], { type: "application/pdf" });
  const url = URL.createObjectURL(blob);

  window.open(url);
};
